import { Grid, IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';

type Props = {
    grid?: boolean;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    caption?: string;
    onChange: (value: { name: string; value: unknown }) => void;
    defVal?: string;
    name: string;
    disabled?: boolean;
    onEnterKey?: () => void;
    [key: string]: unknown;
};

/**
 * Form text
 */
export function SttFormPassword({
    grid = false,
    xs = 12,
    sm = 6,
    md = 3,
    lg,
    xl,
    caption,
    onChange,
    defVal,
    name,
    disabled,
    onEnterKey,
    ...rest
}: Props): React.ReactElement {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    function keyPressed(event: React.KeyboardEvent<HTMLDivElement>) {
        if (
            onEnterKey &&
            onEnterKey.constructor === Function &&
            event.which === 13
        ) {
            onEnterKey();
        }
    }

    const content = (
        <TextField
            fullWidth
            variant="outlined"
            label={caption}
            size="small"
            type={showPassword ? 'text' : 'password'}
            value={defVal || ''}
            onChange={(e: any) => onChange({ name, value: e.target.value })}
            onKeyPress={keyPressed}
            disabled={disabled}
            InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => {
                                setShowPassword(!showPassword);
                            }}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );

    const sizeProps = { xs, sm, md, lg, xl };
    return grid ? (
        <Grid {...rest} size={sizeProps}>
            {content}
        </Grid>
    ) : (
        content
    );
}
